var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTech(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "128.000000pt",
    height: "128.000000pt",
    viewBox: "0,0,256,256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#0073c2",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.07489,0) scale(2,2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,128) scale(0.1,-0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165,1255c-34,-33 -34,-87 0,-121c24,-24 25,-28 25,-175c0,-85 5,-159 10,-170c9,-17 22,-19 100,-19h90v-50v-50h-73c-65,0 -76,3 -97,25c-51,55 -140,19 -140,-56c0,-73 90,-107 140,-54c21,22 32,25 97,25h73v-94c0,-100 10,-126 51,-126c17,0 19,-8 19,-70v-70h-64c-77,0 -96,-6 -96,-30c0,-24 19,-30 101,-30c106,0 109,3 109,110v90h50h50v-73c0,-65 -3,-76 -25,-97c-55,-51 -19,-140 56,-140c73,0 107,90 54,140c-22,21 -25,32 -25,97v73h94c100,0 126,10 126,51c0,17 8,19 70,19h70v-145c0,-140 -1,-145 -25,-169c-52,-52 -17,-146 55,-146c72,0 107,94 55,146c-24,24 -25,28 -25,175c0,85 -5,159 -10,170c-9,17 -22,19 -100,19h-90v50v50h73c65,0 76,-3 97,-25c51,-55 140,-19 140,56c0,73 -90,107 -140,54c-21,-22 -32,-25 -97,-25h-73v94c0,100 -10,126 -51,126c-17,0 -19,8 -19,70v70h64c77,0 96,6 96,30c0,24 -19,30 -101,30c-106,0 -109,-3 -109,-110v-90h-50h-50v73c0,65 3,76 25,97c55,51 19,140 -56,140c-73,0 -107,-90 -54,-140c22,-21 25,-32 25,-97v-73h-94c-100,0 -126,-10 -126,-51c0,-17 -8,-19 -70,-19h-70v145c0,140 1,145 25,169c52,52 17,146 -55,146c-19,0 -40,-9 -55,-25zM245,1195c0,-25 -4,-30 -25,-30c-16,0 -26,6 -28,18c-6,30 6,49 30,45c18,-2 23,-9 23,-33zM665,1120c0,-18 -6,-26 -23,-28c-24,-4 -38,18 -28,44c3,9 15,14 28,12c17,-2 23,-10 23,-28zM830,640v-190h-190h-190v190v190h190h190zM185,640c0,-18 -6,-26 -23,-28c-24,-4 -38,18 -28,44c3,9 15,14 28,12c17,-2 23,-10 23,-28zM1145,640c0,-18 -6,-26 -23,-28c-24,-4 -38,18 -28,44c3,9 15,14 28,12c17,-2 23,-10 23,-28zM665,160c0,-18 -6,-26 -23,-28c-24,-4 -38,18 -28,44c3,9 15,14 28,12c17,-2 23,-10 23,-28zM1085,85c0,-25 -4,-30 -25,-30c-16,0 -26,6 -28,18c-6,30 6,49 30,45c18,-2 23,-9 23,-33z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536,744c-12,-12 -16,-37 -16,-104c0,-116 4,-120 120,-120c67,0 92,4 104,16c12,12 16,37 16,104c0,116 -4,120 -120,120c-67,0 -92,-4 -104,-16zM700,640v-60h-60h-60v60v60h60h60z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1135,1115c-52,-51 -15,-135 60,-135c46,0 85,36 85,80c0,44 -39,80 -85,80c-25,0 -44,-8 -60,-25zM1225,1060c0,-20 -6,-26 -28,-28c-29,-4 -44,16 -33,44c4,10 15,14 33,12c22,-2 28,-8 28,-28z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1030,1060c0,-13 7,-20 20,-20c13,0 20,7 20,20c0,13 -7,20 -20,20c-13,0 -20,-7 -20,-20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,275c-52,-51 -15,-135 60,-135c46,0 85,36 85,80c0,44 -39,80 -85,80c-25,0 -44,-8 -60,-25zM115,220c0,-20 -6,-26 -28,-28c-18,-2 -29,2 -33,12c-11,28 4,48 33,44c22,-2 28,-8 28,-28z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210,220c0,-13 7,-20 20,-20c13,0 20,7 20,20c0,13 -7,20 -20,20c-13,0 -20,-7 -20,-20z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTech);
export default __webpack_public_path__ + "static/media/tech.75af6e301c8331872313c02c9d74a08f.svg";
export { ForwardRef as ReactComponent };